package ru.villawonka.app.presentation.screens.searchFilter.model

data class ChipUIModel<T>(
    val text: String,
    val selected: Boolean,
    val payload: T
)